import React, { useState, useEffect } from 'react';
import { Card } from '../components/ui/card';
import { Twitter } from 'lucide-react';

const Home = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showStickyButton, setShowStickyButton] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Sticky button on scroll (mobile only)
    const handleScroll = () => {
      if (window.innerWidth <= 768) {
        setShowStickyButton(window.scrollY > 300);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Ensure video loops continuously
    const video = document.querySelector('video');
    if (video) {
      video.loop = true;
      video.muted = true;
      video.play().catch(err => console.log('Video autoplay prevented:', err));
      
      // Force loop if video ends
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.play();
      });
    }
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handlePrivacyClick = () => {
    window.open('https://privacy.com.br/checkout/Isadoravale', '_blank');
  };

  const handleTwitter = () => {
    window.open('https://twitter.com/Isadoravallee', '_blank');
  };

  const photos = [
    {
      url: 'https://customer-assets.emergentagent.com/job_isadora-convert/artifacts/80lyyni0_IMG_5387.jpg',
      label: 'Conteúdo Exclusivo'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_isadora-convert/artifacts/4g3awxee_IMG_5444.jpg',
      label: 'Fotos Premium'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_isadora-convert/artifacts/havme9xo_IMG_5664.jpg',
      label: 'Intimidade Real'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black relative overflow-hidden">
      {/* Ambient background effects */}
      <div className="fixed top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-pink-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-rose-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        
        {/* Header - Name + Subtitle */}
        <div 
          className={`text-center mb-6 sm:mb-8 transform transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'
          }`}
        >
          <h1 
            onClick={handlePrivacyClick}
            className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight mb-3 cursor-pointer hover:scale-105 transition-transform duration-300"
          >
            <span className="bg-gradient-to-r from-pink-200 via-rose-200 to-pink-300 bg-clip-text text-transparent">
              Isadora Vale
            </span>
          </h1>
          <p 
            onClick={handlePrivacyClick}
            className="text-pink-200/70 text-sm sm:text-base cursor-pointer hover:text-pink-200 transition-colors duration-300"
          >
            Descubra meus segredos
          </p>
        </div>

        {/* Hero Photo - NEW */}
        <div 
          className={`mb-6 sm:mb-8 transform transition-all duration-1000 delay-100 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <Card 
            className="relative overflow-hidden cursor-pointer group bg-gradient-to-br from-pink-900/20 to-rose-900/20 border-pink-500/30 hover:border-pink-500/60 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-pink-500/30 max-w-3xl mx-auto"
            onClick={handlePrivacyClick}
          >
            <div className="relative aspect-[4/3] sm:aspect-[16/9] w-full overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_isadora-convert/artifacts/r5mtru7r_IMG_3901.jpg"
                alt="Isadora Vale"
                className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
                style={{ filter: 'brightness(1.05) contrast(1.05)' }}
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              {/* Label overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-2">laranjinha</h2>
                <p className="text-pink-200 text-sm sm:text-base">Clique para acessar conteúdo exclusivo</p>
              </div>
            </div>
          </Card>
        </div>

        {/* CTA Section with Offer - Below Photo */}
        <div 
          className={`text-center mb-6 sm:mb-8 transform transition-all duration-1000 delay-200 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 max-w-2xl mx-auto">
            {/* Offer Text - No background */}
            <p className="text-pink-200/90 text-sm sm:text-base font-semibold">
              🎁 50% de desconto - Oferta limitada
            </p>
            {/* CTA Button - Smaller */}
            <button
              onClick={handlePrivacyClick}
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold text-sm sm:text-base px-6 sm:px-10 py-2.5 sm:py-3.5 rounded-full shadow-2xl hover:shadow-pink-500/60 transition-all duration-300 hover:scale-105 border-2 border-pink-300/40 whitespace-nowrap"
            >
              Quero ver agora!
            </button>
          </div>
        </div>

        {/* Teaser text */}
        <div 
          className={`text-center mb-8 sm:mb-12 transform transition-all duration-1000 delay-250 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <p className="text-pink-200/60 text-xs sm:text-sm italic">
            "O que você sempre quis ver, está a um clique de distância"
          </p>
        </div>

        {/* Hero Video */}
        <div 
          className={`mb-6 sm:mb-8 transform transition-all duration-1000 delay-100 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <Card 
            className="relative overflow-hidden cursor-pointer group bg-gradient-to-br from-pink-900/20 to-rose-900/20 border-pink-500/30 hover:border-pink-500/60 transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl hover:shadow-pink-500/30 max-w-3xl mx-auto"
            onClick={handlePrivacyClick}
          >
            <div className="relative aspect-[4/3] sm:aspect-[16/9] w-full overflow-hidden bg-black">
              <video
                autoPlay
                loop
                muted
                playsInline
                poster="https://customer-assets.emergentagent.com/job_isadora-convert/artifacts/80lyyni0_IMG_5387.jpg"
                className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
                style={{ filter: 'brightness(0.9) contrast(1.1)' }}
              >
                <source src="https://customer-assets.emergentagent.com/job_2b2051e5-8525-4281-8f03-e91549027e5e/artifacts/nf87jhbv_d537d0272ae949b296041f7b702d6683.mov" type="video/quicktime" />
                <source src="https://customer-assets.emergentagent.com/job_2b2051e5-8525-4281-8f03-e91549027e5e/artifacts/nf87jhbv_d537d0272ae949b296041f7b702d6683.mov" type="video/mp4" />
              </video>
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              {/* Label overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                <h2 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-2">laranjinha</h2>
                <p className="text-pink-200 text-sm sm:text-base">Clique para acessar conteúdo exclusivo</p>
              </div>
            </div>
          </Card>
        </div>

        {/* CTA Section - Below Video */}
        <div 
          className={`text-center mb-8 sm:mb-12 transform transition-all duration-1000 delay-200 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <button
            onClick={handlePrivacyClick}
            className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold text-base sm:text-lg px-8 sm:px-12 py-3 sm:py-4 rounded-full shadow-2xl hover:shadow-pink-500/60 transition-all duration-300 hover:scale-105 border-2 border-pink-300/40"
          >
            Quero ver agora!
          </button>
          <p className="text-pink-200/60 text-xs sm:text-sm mt-4 italic">
            "O que você sempre quis ver, está a um clique de distância"
          </p>
        </div>

        {/* Photo Grid */}
        <div 
          className={`grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 transform transition-all duration-1000 delay-300 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          {photos.map((photo, index) => (
            <Card
              key={index}
              className="relative overflow-hidden cursor-pointer group bg-gradient-to-br from-pink-900/20 to-rose-900/20 border-pink-500/30 hover:border-pink-500/60 transition-all duration-300 hover:shadow-xl hover:shadow-pink-500/20"
              onClick={handlePrivacyClick}
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={photo.url}
                  alt={photo.label}
                  loading="lazy"
                  className="w-full h-full object-cover transition-all duration-300 group-hover:scale-105 group-hover:blur-0 blur-[1px]"
                  style={{ filter: 'brightness(1.1) contrast(1.05)' }}
                />
                {/* Overlay gradient - simplified */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                {/* Label */}
                <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <h3 className="text-white text-xl sm:text-2xl font-bold">{photo.label}</h3>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Second CTA after photos */}
        <div 
          className={`text-center mt-12 sm:mt-16 transform transition-all duration-1000 delay-400 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <div className="max-w-xl mx-auto bg-gradient-to-br from-pink-500/10 to-rose-500/10 backdrop-blur-sm border border-pink-400/30 rounded-3xl p-8 sm:p-10">
            <p className="text-2xl sm:text-3xl text-pink-100 font-bold mb-6">
              Pronta para me conhecer de verdade? 🔥
            </p>
            <button
              onClick={handlePrivacyClick}
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold text-xl sm:text-2xl px-12 sm:px-16 py-5 sm:py-6 rounded-full shadow-2xl hover:shadow-pink-500/60 transition-all duration-300 hover:scale-105 border-2 border-pink-300/40 w-full sm:w-auto"
            >
              Quero acesso agora!
            </button>
          </div>
        </div>

        {/* Bottom CTA */}
        <div 
          className={`text-center mt-8 sm:mt-12 transform transition-all duration-1000 delay-600 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}
        >
          <p className="text-pink-200/60 text-sm sm:text-base mb-4">
            🔥 Clique em qualquer foto ou vídeo para acessar
          </p>
          <p className="text-pink-300/50 text-xs sm:text-sm italic mb-8">
            "O que você sempre quis ver, está a um clique de distância..."
          </p>
          
          {/* Twitter at bottom */}
          <div className="pt-8 border-t border-pink-500/20">
            <p className="text-pink-200/50 text-sm mb-4">Me siga também:</p>
            <button
              onClick={handleTwitter}
              className="inline-flex items-center justify-center bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-md border border-pink-500/30 p-4 rounded-full hover:bg-gradient-to-br hover:from-white/15 hover:to-white/10 hover:border-pink-500/50 transition-all duration-300 hover:scale-110 group"
              aria-label="Twitter"
            >
              <Twitter className="w-6 h-6 text-pink-300 group-hover:text-pink-400 transition-colors" />
            </button>
          </div>
        </div>
      </div>

      {/* Sticky CTA Button (Mobile Only) - Smaller & Softer */}
      <div 
        className={`fixed bottom-0 left-0 right-0 z-50 p-3 bg-gradient-to-t from-black/80 via-black/70 to-transparent md:hidden transition-all duration-300 ${
          showStickyButton ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
      >
        <button
          onClick={handlePrivacyClick}
          className="w-full bg-gradient-to-r from-pink-500/90 to-rose-500/90 hover:from-pink-600 hover:to-rose-600 text-white font-semibold text-sm px-6 py-3 rounded-full shadow-lg hover:shadow-pink-500/40 transition-all duration-300 border border-pink-300/20"
        >
          Ver agora 🔥
        </button>
      </div>
    </div>
  );
};

export default Home;